import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';


const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    appId: "Patient Portal",
    connectionString: process.env.APPINSIGHTS_CONNECTION_STRING,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    disableAjaxTracking: true,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true
  }
});
appInsights.loadAppInsights();

appInsights.addTelemetryInitializer((env) => {
  env.tags = env.tags || [];
  env.tags["ai.cloud.role"] = "Patient Portal";
  env.data.baseData.properties = {
    name: "Patient Portal"
  }
});


/*browserHistory.listen((location) => {
  const pathNames = (location?.pathname.split('/'))
    .filter(n => n);

  let pageName = '/'
  if (pathNames.length > 0) {
    pageName = pathNames[pathNames.length - 1]
  }
  appInsights.trackPageView({ name: pageName, uri: location.pathname });
});*/

export { reactPlugin, appInsights };


